import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';
import logo from "../../assets/logo.png"; // Ensure this path matches your project structure

const Footer = () => {
  const [logoError, setLogoError] = useState(false);

  return (
    <footer className="footer-wrapper">
      
      {/* Top Accent Gradient Bar */}
      <div className="footer-top-accent"></div>

      <div className="footer-container">
        
        {/* ================= MAIN 4-COLUMN GRID ================= */}
        <div className="footer-main-grid">
          
          {/* 1. BRAND COLUMN (300PX DESKTOP LOGO) */}
          <div className="footer-col-brand">
            <div className="footer-big-logo">
              <Link to="/" aria-label="Nutrivio Home">
                {!logoError ? (
                  <img 
                    src={logo} 
                    alt="Nutrivio Medical Services Private Limited" 
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <div className="footer-logo-fallback">
                    <span className="footer-fallback-icon">⚕</span>
                    <div className="footer-fallback-text">
                      <strong>NUTRIVIO</strong>
                      <small>MEDICAL SERVICES</small>
                    </div>
                  </div>
                )}
              </Link>
            </div>
          </div>

          {/* 2. OUR SERVICES */}
          <div className="footer-col footer-col-services">
            <h4 className="footer-col-title">Our Services</h4>
            <ul className="footer-nav-list">
              <li>
                <Link to="/services/new-medical-college-establishment" className="footer-nav-link">
                  New Medical College Establishment
                </Link>
              </li>
              <li>
                <Link to="/services/mbbs-seat-expansion" className="footer-nav-link">
                  MBBS Seat Expansion
                </Link>
              </li>
              <li>
                <Link to="/services/pg-course-seat-expansion" className="footer-nav-link">
                  PG (MD/MS) Course &amp; Seat Expansion
                </Link>
              </li>
              <li>
                <Link to="/services/institutional-compliance" className="footer-nav-link">
                  Institutional &amp; Teaching Hospital Compliance
                </Link>
              </li>
              <li>
                <Link to="/services/documentation-readiness" className="footer-nav-link">
                  Documentation &amp; Institutional Readiness
                </Link>
              </li>
              <li>
                <Link to="/services/medical-faculty-recruitment" className="footer-nav-link">
                  Medical Faculty Recruitment
                </Link>
              </li>
            </ul>
          </div>

          {/* 3. QUICK LINKS (2x2 GRID ON MOBILE) */}
          <div className="footer-col footer-col-quicklinks">
            <h4 className="footer-col-title">Quick Links</h4>
            <ul className="footer-nav-list footer-quick-nav-list">
              <li>
                <Link to="/" className="footer-nav-link">Home</Link>
              </li>
              <li>
                <Link to="/about" className="footer-nav-link">About Us</Link>
              </li>
              <li>
                <Link to="/services" className="footer-nav-link">Services</Link>
              </li>
              <li>
                <Link to="/gallery" className="footer-nav-link">Gallery</Link>
              </li>
              <li>
                <Link to="/for-institutions" className="footer-nav-link">For Institutions</Link>
              </li>
              <li>
                <Link to="/for-medical-faculty" className="footer-nav-link">For Medical Faculty</Link>
              </li>
              <li>
                <Link to="/contact" className="footer-nav-link">Contact Us</Link>
              </li>
            </ul>
          </div>

          {/* 4. OFFICE ADDRESS, DIRECT CONTACT & SOCIALS */}
          <div className="footer-col footer-col-contact">
            <h4 className="footer-col-title">Office &amp; Contact</h4>
            
            {/* Address Card */}
            <div className="footer-address-card">
              <div className="footer-address-icon">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                  <path d="M3 21h18M3 10h18M5 6l7-3 7 3M4 10v11M20 10v11M8 14v3M12 14v3M16 14v3"/>
                </svg>
              </div>
              <div className="footer-address-info">
                <strong>Registered &amp; Corporate Office</strong>
                <p>Mani Casadona, IT/ITES Hub, New Town, Rajarhat, Kolkata, WB – 700161</p>
              </div>
            </div>

            {/* Direct Contact Links */}
            <div className="footer-direct-contacts">
              <a href="tel:+919038320103" className="footer-contact-link-pill">
                <div className="footer-pill-icon">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"/>
                  </svg>
                </div>
                <span>+91 90383 20103</span>
              </a>

              <a href="https://wa.me/919038320103" target="_blank" rel="noopener noreferrer" className="footer-contact-link-pill whatsapp">
                <div className="footer-pill-icon green">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                    <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/>
                  </svg>
                </div>
                <span>WhatsApp No: +91 9038320103</span>
              </a>

              <a href="mailto:nutrivioheadoffice@gmail.com" className="footer-contact-link-pill">
                <div className="footer-pill-icon">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                    <polyline points="22,6 12,13 2,6"/>
                  </svg>
                </div>
                <span>nutrivioheadoffice@gmail.com</span>
              </a>
            </div>

            {/* Social Channels */}
            <div className="footer-social-wrapper">
              <span className="footer-social-header">Official Channels</span>
              <div className="footer-social-icons">
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="LinkedIn">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                    <rect x="2" y="9" width="4" height="12"/>
                    <circle cx="4" cy="4" r="2"/>
                  </svg>
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Twitter">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M4 4l11.733 16h4.267l-11.733 -16z" />
                    <path d="M4 20l6.768 -6.768m2.46 -2.46l6.772 -6.772" />
                  </svg>
                </a>
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="Facebook">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                  </svg>
                </a>
                <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="footer-social-btn" aria-label="YouTube">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"/>
                    <polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"/>
                  </svg>
                </a>
              </div>
            </div>

          </div>

        </div>

        {/* ================= REGULATORY DISCLAIMER STRIP ================= */}
        <div className="footer-disclaimer-strip">
          <p>
            <strong>Disclaimer:</strong> Nutrivio Medical Services Private Limited provides independent professional advisory, recruitment, and documentation support. Regulatory permissions remain subject to applicable statutory laws, eligibility assessments, and competent authority decisions. No approval is represented as guaranteed.
          </p>
        </div>

        {/* ================= CLEAN BALANCED BOTTOM BAR ================= */}
        <div className="footer-bottom-bar">
          
          {/* LEFT: COPYRIGHT & CREDIT */}
          <div className="footer-copyright-column">
            <span className="footer-copyright-text">
              &copy; {new Date().getFullYear()} Nutrivio Medical Services Private Limited. All Rights Reserved.
            </span>
            <span className="footer-dev-credit">
              Developed &amp; Designed with <span className="footer-heart">❤️</span> by <a href="https://dheersoftwaresolutions.com/" target="_blank" rel="noopener noreferrer">Dheer Software Solutions</a>
            </span>
          </div>

          {/* RIGHT: LEGAL LINKS */}
          <div className="footer-legal-links">
            <Link to="/privacy-policy" className="footer-legal-link">Privacy Policy</Link>
            <span className="footer-legal-divider">&bull;</span>
            <Link to="/terms-and-conditions" className="footer-legal-link">Terms &amp; Conditions</Link>
            <span className="footer-legal-divider">&bull;</span>
            <Link to="/disclaimer" className="footer-legal-link">Disclaimer</Link>
            <span className="footer-legal-divider">&bull;</span>
            <Link to="/cookie-policy" className="footer-legal-link">Cookie Policy</Link>
          </div>

        </div>

      </div>
    </footer>
  );
};

export default Footer;